@if (platformService.isIos) {
  @if (pendingRedirectUrl) {
    <!-- iOS App Clip Pre-Launch Guide (first visit, before user taps Show AppClip) -->
    <div
      class="flex min-h-dvh w-full flex-col items-center justify-center p-6 text-center"
      [style.background-color]="brand.iconBgColor"
    >
      <div
        class="animate-fade-in mx-auto flex w-full max-w-lg flex-col items-center rounded-3xl bg-white p-6 text-left shadow-xl select-none md:p-8"
      >
        <!-- Igloo Brand Logo (Colored) -->
        <svg
          width="110"
          height="30"
          viewBox="0 0 73 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="mx-auto select-none"
        >
          <path
            d="M0 5.43044V19.994H14.5979C17.6048 19.994 20.0411 17.5635 20.0411 14.5636V0H5.44322C2.43622 0 0 2.43051 0 5.43044ZM14.5282 18.1691C12.5208 18.1691 10.8948 16.5469 10.8948 14.5441C10.8948 12.5414 12.5208 10.9192 14.5282 10.9192C16.5357 10.9192 18.1617 12.5414 18.1617 14.5441C18.1617 16.5469 16.5357 18.1691 14.5282 18.1691ZM18.1812 1.83885V9.12759H10.8753C10.8753 5.10267 14.1468 1.83885 18.1812 1.83885ZM9.14628 1.83885V18.1718H1.81812V5.48878C1.81812 3.47215 3.45526 1.83885 5.47663 1.83885H9.14628Z"
            fill="#ec2a26"
          />
          <path
            d="M27.9775 5.18652H27.3343C26.5046 5.18652 25.8336 5.85595 25.8336 6.68371V15.9141C25.8336 16.2196 26.0842 16.4696 26.3905 16.4696H27.9775C28.2921 16.4696 28.5483 16.2141 28.5483 15.9002V5.75874C28.5483 5.44485 28.2921 5.1893 27.9775 5.1893V5.18652Z"
            fill="#ec2a26"
          />
          <path
            d="M46.014 0.0065918H45.3708C44.5411 0.0065918 43.8701 0.676024 43.8701 1.50378V15.9146C43.8701 16.2201 44.1207 16.4701 44.427 16.4701H46.014C46.3286 16.4701 46.5848 16.2146 46.5848 15.9007V0.578804C46.5848 0.264921 46.3286 0.00937011 46.014 0.00937011V0.0065918Z"
            fill="#ec2a26"
          />
          <path
            d="M27.1888 0.295166C26.1586 0.295166 25.3177 1.13126 25.3177 2.16179C25.3177 3.19233 26.1558 4.02842 27.1888 4.02842C28.2217 4.02842 29.0598 3.19233 29.0598 2.16179C29.0598 1.13126 28.2217 0.295166 27.1888 0.295166Z"
            fill="#ec2a26"
          />
          <path
            d="M53.9632 4.93091C50.7752 4.93091 48.1803 7.51974 48.1803 10.7002C48.1803 13.8807 50.7752 16.4696 53.9632 16.4696C57.1512 16.4696 59.7461 13.8807 59.7461 10.7002C59.7461 7.51974 57.1512 4.93091 53.9632 4.93091ZM53.9938 13.8557C52.2676 13.8557 50.8615 12.453 50.8615 10.7308C50.8615 9.0086 52.2648 7.60585 53.9938 7.60585C55.7229 7.60585 57.1261 9.00582 57.1261 10.7308C57.1261 12.4558 55.7229 13.8557 53.9938 13.8557Z"
            fill="#ec2a26"
          />
          <path
            d="M66.8093 4.93091C63.6213 4.93091 61.0264 7.51974 61.0264 10.7002C61.0264 13.8807 63.6213 16.4696 66.8093 16.4696C69.9972 16.4696 72.5922 13.8807 72.5922 10.7002C72.5922 7.51974 69.9972 4.93091 66.8093 4.93091ZM66.8399 13.8557C65.1137 13.8557 63.7076 12.453 63.7076 10.7308C63.7076 9.0086 65.1109 7.60585 66.8399 7.60585C68.5689 7.60585 69.9722 9.00582 69.9722 10.7308C69.9722 12.4558 68.5661 13.8557 66.8399 13.8557Z"
            fill="#ec2a26"
          />
          <path
            d="M41.4972 5.21701H40.6063C40.0327 5.21701 39.5399 5.55312 39.3116 6.03922C39.1306 5.90867 38.9468 5.78367 38.7492 5.67534C37.886 5.18924 36.9032 4.93091 35.9064 4.93091C32.7185 4.93091 30.1235 7.51974 30.1235 10.7002C30.1235 13.8807 32.7185 16.4696 35.9064 16.4696C36.8475 16.4696 37.783 16.239 38.6099 15.8001C38.8076 15.6946 38.9942 15.5779 39.1779 15.4557C39.1779 16.5168 38.3176 17.3751 37.2568 17.3779H37.0925C36.3213 17.3779 35.6976 18.0029 35.6976 18.7723V19.5001C35.6976 19.775 35.9204 20 36.1988 20H37.6939C40.0717 20 42.0012 18.0779 42.0012 15.7029V5.71423C42.0012 5.43923 41.7784 5.21423 41.5 5.21423L41.4972 5.21701ZM38.248 12.628C37.6048 13.4696 36.5997 13.9252 35.5278 13.8502C33.9909 13.7418 32.7463 12.4946 32.6377 10.9613C32.5069 9.13638 33.9575 7.61141 35.7589 7.61141C36.7445 7.61141 37.6494 8.05862 38.248 8.83916C38.6684 9.38637 38.8884 10.0419 38.8884 10.7336C38.8884 11.4252 38.6656 12.0808 38.2452 12.628H38.248Z"
            fill="#ec2a26"
          />
        </svg>

        <h1
          class="mt-6 text-center font-sans text-xl leading-tight font-extrabold tracking-tight text-[#1a1a1a] md:text-2xl"
        >
          You have received a short-term access link.
        </h1>

        <p class="mt-3 text-center text-[13px] leading-relaxed text-gray-500 md:text-sm">
          Tap <strong class="font-extrabold text-gray-800">"Show App Clip"</strong> below. When this
          popup appears, tap <strong class="font-extrabold text-gray-800">"Open App Clip"</strong>:
        </p>

        <!-- App Clip popup mockup illustration -->
        <div class="pointer-events-none mt-5 w-full max-w-[280px] self-center select-none">
          <!-- Mockup card -->
          <div class="overflow-hidden rounded-2xl shadow-lg">
            <!-- Teal header with lock device silhouettes -->
            <div
              class="relative flex items-center justify-between px-4 py-3"
              [style.background-color]="brand.iconBgColor"
            >
              <!-- Subtle lock device outlines in background -->
              <svg
                class="absolute inset-0 h-full w-full opacity-15"
                viewBox="0 0 280 72"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid slice"
              >
                <!-- Padlock 1 -->
                <rect
                  x="8"
                  y="18"
                  width="22"
                  height="18"
                  rx="3"
                  stroke="white"
                  stroke-width="1.5"
                  fill="none"
                />
                <path
                  d="M13 18v-5a6 6 0 0 1 12 0v5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  fill="none"
                />
                <!-- Round puck lock -->
                <circle cx="60" cy="30" r="12" stroke="white" stroke-width="1.5" fill="none" />
                <circle cx="60" cy="30" r="5" stroke="white" stroke-width="1.5" fill="none" />
                <!-- Tall rectangular keypad -->
                <rect
                  x="98"
                  y="10"
                  width="20"
                  height="40"
                  rx="4"
                  stroke="white"
                  stroke-width="1.5"
                  fill="none"
                />
                <rect
                  x="103"
                  y="16"
                  width="10"
                  height="8"
                  rx="1.5"
                  stroke="white"
                  stroke-width="1"
                  fill="none"
                />
                <circle cx="108" cy="32" r="3" stroke="white" stroke-width="1" fill="none" />
                <!-- Slim padlock -->
                <rect
                  x="143"
                  y="20"
                  width="16"
                  height="16"
                  rx="3"
                  stroke="white"
                  stroke-width="1.5"
                  fill="none"
                />
                <path
                  d="M147 20v-4a4 4 0 0 1 8 0v4"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  fill="none"
                />
                <!-- Wide keypad -->
                <rect
                  x="178"
                  y="14"
                  width="30"
                  height="36"
                  rx="4"
                  stroke="white"
                  stroke-width="1.5"
                  fill="none"
                />
                <rect
                  x="183"
                  y="20"
                  width="8"
                  height="6"
                  rx="1"
                  stroke="white"
                  stroke-width="1"
                  fill="none"
                />
                <rect
                  x="195"
                  y="20"
                  width="8"
                  height="6"
                  rx="1"
                  stroke="white"
                  stroke-width="1"
                  fill="none"
                />
                <circle cx="193" cy="35" r="3.5" stroke="white" stroke-width="1" fill="none" />
                <!-- Round-top padlock -->
                <rect
                  x="232"
                  y="22"
                  width="24"
                  height="18"
                  rx="3"
                  stroke="white"
                  stroke-width="1.5"
                  fill="none"
                />
                <path
                  d="M237 22v-6a7 7 0 0 1 14 0v6"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  fill="none"
                />
              </svg>
              <!-- White igloo wordmark -->
              <svg
                width="64"
                height="17"
                viewBox="0 0 73 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="relative z-10"
              >
                <path
                  d="M0 5.43044V19.994H14.5979C17.6048 19.994 20.0411 17.5635 20.0411 14.5636V0H5.44322C2.43622 0 0 2.43051 0 5.43044ZM14.5282 18.1691C12.5208 18.1691 10.8948 16.5469 10.8948 14.5441C10.8948 12.5414 12.5208 10.9192 14.5282 10.9192C16.5357 10.9192 18.1617 12.5414 18.1617 14.5441C18.1617 16.5469 16.5357 18.1691 14.5282 18.1691ZM18.1812 1.83885V9.12759H10.8753C10.8753 5.10267 14.1468 1.83885 18.1812 1.83885ZM9.14628 1.83885V18.1718H1.81812V5.48878C1.81812 3.47215 3.45526 1.83885 5.47663 1.83885H9.14628Z"
                  fill="white"
                />
                <path
                  d="M27.9775 5.18652H27.3343C26.5046 5.18652 25.8336 5.85595 25.8336 6.68371V15.9141C25.8336 16.2196 26.0842 16.4696 26.3905 16.4696H27.9775C28.2921 16.4696 28.5483 16.2141 28.5483 15.9002V5.75874C28.5483 5.44485 28.2921 5.1893 27.9775 5.1893V5.18652Z"
                  fill="white"
                />
                <path
                  d="M46.014 0.0065918H45.3708C44.5411 0.0065918 43.8701 0.676024 43.8701 1.50378V15.9146C43.8701 16.2201 44.1207 16.4701 44.427 16.4701H46.014C46.3286 16.4701 46.5848 16.2146 46.5848 15.9007V0.578804C46.5848 0.264921 46.3286 0.00937011 46.014 0.00937011V0.0065918Z"
                  fill="white"
                />
                <path
                  d="M27.1888 0.295166C26.1586 0.295166 25.3177 1.13126 25.3177 2.16179C25.3177 3.19233 26.1558 4.02842 27.1888 4.02842C28.2217 4.02842 29.0598 3.19233 29.0598 2.16179C29.0598 1.13126 28.2217 0.295166 27.1888 0.295166Z"
                  fill="white"
                />
                <path
                  d="M53.9632 4.93091C50.7752 4.93091 48.1803 7.51974 48.1803 10.7002C48.1803 13.8807 50.7752 16.4696 53.9632 16.4696C57.1512 16.4696 59.7461 13.8807 59.7461 10.7002C59.7461 7.51974 57.1512 4.93091 53.9632 4.93091ZM53.9938 13.8557C52.2676 13.8557 50.8615 12.453 50.8615 10.7308C50.8615 9.0086 52.2648 7.60585 53.9938 7.60585C55.7229 7.60585 57.1261 9.00582 57.1261 10.7308C57.1261 12.4558 55.7229 13.8557 53.9938 13.8557Z"
                  fill="white"
                />
                <path
                  d="M66.8093 4.93091C63.6213 4.93091 61.0264 7.51974 61.0264 10.7002C61.0264 13.8807 63.6213 16.4696 66.8093 16.4696C69.9972 16.4696 72.5922 13.8807 72.5922 10.7002C72.5922 7.51974 69.9972 4.93091 66.8093 4.93091ZM66.8399 13.8557C65.1137 13.8557 63.7076 12.453 63.7076 10.7308C63.7076 9.0086 65.1109 7.60585 66.8399 7.60585C68.5689 7.60585 69.9722 9.00582 69.9722 10.7308C69.9722 12.4558 68.5661 13.8557 66.8399 13.8557Z"
                  fill="white"
                />
                <path
                  d="M41.4972 5.21701H40.6063C40.0327 5.21701 39.5399 5.55312 39.3116 6.03922C39.1306 5.90867 38.9468 5.78367 38.7492 5.67534C37.886 5.18924 36.9032 4.93091 35.9064 4.93091C32.7185 4.93091 30.1235 7.51974 30.1235 10.7002C30.1235 13.8807 32.7185 16.4696 35.9064 16.4696C36.8475 16.4696 37.783 16.239 38.6099 15.8001C38.8076 15.6946 38.9942 15.5779 39.1779 15.4557C39.1779 16.5168 38.3176 17.3751 37.2568 17.3779H37.0925C36.3213 17.3779 35.6976 18.0029 35.6976 18.7723V19.5001C35.6976 19.775 35.9204 20 36.1988 20H37.6939C40.0717 20 42.0012 18.0779 42.0012 15.7029V5.71423C42.0012 5.43923 41.7784 5.21423 41.5 5.21423L41.4972 5.21701ZM38.248 12.628C37.6048 13.4696 36.5997 13.9252 35.5278 13.8502C33.9909 13.7418 32.7463 12.4946 32.6377 10.9613C32.5069 9.13638 33.9575 7.61141 35.7589 7.61141C36.7445 7.61141 37.6494 8.05862 38.248 8.83916C38.6684 9.38637 38.8884 10.0419 38.8884 10.7336C38.8884 11.4252 38.6656 12.0808 38.2452 12.628H38.248Z"
                  fill="white"
                />
              </svg>
              <!-- Close button -->
              <div
                class="relative z-10 flex h-6 w-6 items-center justify-center rounded-full bg-white/20"
              >
                <span class="text-[10px] leading-none text-white">✕</span>
              </div>
            </div>
            <!-- Mockup body -->
            <div class="bg-white px-4 py-3">
              <p class="text-sm font-bold text-gray-900">iglooKey</p>
              <p class="mt-0.5 text-[11px] text-gray-500">Tap Open to unlock with iglooKey</p>
              <div class="mt-3 flex gap-2">
                <div
                  class="flex-1 rounded-lg border border-gray-200 py-1.5 text-center text-[11px] font-semibold text-gray-500"
                >
                  Show in Safari
                </div>
                <div
                  class="flex-1 rounded-lg border border-[#007aff] py-1.5 text-center text-[11px] font-semibold text-[#007aff]"
                >
                  Open App Clip
                </div>
              </div>
              <div class="mt-3 flex items-center justify-between border-t border-gray-100 pt-2.5">
                <div class="flex items-center gap-1.5">
                  <div
                    class="flex h-5 w-5 items-center justify-center rounded-md"
                    [style.background-color]="brand.iconBgColor"
                  >
                    <svg class="h-3 w-3 text-white" viewBox="0 0 20 20" fill="none">
                      <rect
                        x="4"
                        y="9"
                        width="12"
                        height="9"
                        rx="2"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                      />
                      <path
                        d="M7 9V6.5a3 3 0 0 1 6 0V9"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        fill="none"
                      />
                    </svg>
                  </div>
                  <span class="text-[10px] text-gray-500"
                    >Powered by <span class="font-semibold">igloo</span></span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- Arrow pointing up to Open App Clip button (right half of card) -->
          <div class="mt-1.5 flex items-center justify-end gap-1 pr-4">
            <span class="text-[11px] font-semibold" [style.color]="brand.iconBgColor"
              >Tap this button</span
            >
            <svg
              class="h-4 w-4 -rotate-90"
              [style.color]="brand.iconBgColor"
              viewBox="0 0 16 16"
              fill="currentColor"
            >
              <path d="M8 2l-1.4 1.4L10.2 7H2v2h8.2l-3.6 3.6L8 14l6-6-6-6z" />
            </svg>
          </div>
        </div>

        <!-- CTA link — must be a real <a> so iOS triggers the App Clip banner -->
        <a
          [href]="pendingRedirectUrl"
          class="mt-6 block w-full rounded-xl py-3.5 text-center text-sm font-bold tracking-wide text-white shadow-sm"
          [style.background-color]="brand.iconBgColor"
        >
          Show App Clip
        </a>

        <p class="mt-4 text-center text-xs font-semibold text-gray-400">No Download Required</p>
      </div>
    </div>
  } @else {
    <!-- iOS App Clip Recovery Guide (shown after App Clip dismissed) -->
    <div
      class="flex min-h-dvh w-full flex-col items-center p-6 pt-12 text-center"
      [style.background-color]="brand.pageBgColor"
    >
      <div
        class="animate-fade-in mx-auto flex w-full max-w-lg flex-col items-center rounded-3xl bg-white p-6 text-left shadow-xl select-none md:p-8"
      >
        <!-- Igloo Brand Logo (Colored) -->
        <svg
          width="110"
          height="30"
          viewBox="0 0 73 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="mx-auto select-none"
        >
          <path
            d="M0 5.43044V19.994H14.5979C17.6048 19.994 20.0411 17.5635 20.0411 14.5636V0H5.44322C2.43622 0 0 2.43051 0 5.43044ZM14.5282 18.1691C12.5208 18.1691 10.8948 16.5469 10.8948 14.5441C10.8948 12.5414 12.5208 10.9192 14.5282 10.9192C16.5357 10.9192 18.1617 12.5414 18.1617 14.5441C18.1617 16.5469 16.5357 18.1691 14.5282 18.1691ZM18.1812 1.83885V9.12759H10.8753C10.8753 5.10267 14.1468 1.83885 18.1812 1.83885ZM9.14628 1.83885V18.1718H1.81812V5.48878C1.81812 3.47215 3.45526 1.83885 5.47663 1.83885H9.14628Z"
            fill="#ec2a26"
          />
          <path
            d="M27.9775 5.18652H27.3343C26.5046 5.18652 25.8336 5.85595 25.8336 6.68371V15.9141C25.8336 16.2196 26.0842 16.4696 26.3905 16.4696H27.9775C28.2921 16.4696 28.5483 16.2141 28.5483 15.9002V5.75874C28.5483 5.44485 28.2921 5.1893 27.9775 5.1893V5.18652Z"
            fill="#ec2a26"
          />
          <path
            d="M46.014 0.0065918H45.3708C44.5411 0.0065918 43.8701 0.676024 43.8701 1.50378V15.9146C43.8701 16.2201 44.1207 16.4701 44.427 16.4701H46.014C46.3286 16.4701 46.5848 16.2146 46.5848 15.9007V0.578804C46.5848 0.264921 46.3286 0.00937011 46.014 0.00937011V0.0065918Z"
            fill="#ec2a26"
          />
          <path
            d="M27.1888 0.295166C26.1586 0.295166 25.3177 1.13126 25.3177 2.16179C25.3177 3.19233 26.1558 4.02842 27.1888 4.02842C28.2217 4.02842 29.0598 3.19233 29.0598 2.16179C29.0598 1.13126 28.2217 0.295166 27.1888 0.295166Z"
            fill="#ec2a26"
          />
          <path
            d="M53.9632 4.93091C50.7752 4.93091 48.1803 7.51974 48.1803 10.7002C48.1803 13.8807 50.7752 16.4696 53.9632 16.4696C57.1512 16.4696 59.7461 13.8807 59.7461 10.7002C59.7461 7.51974 57.1512 4.93091 53.9632 4.93091ZM53.9938 13.8557C52.2676 13.8557 50.8615 12.453 50.8615 10.7308C50.8615 9.0086 52.2648 7.60585 53.9938 7.60585C55.7229 7.60585 57.1261 9.00582 57.1261 10.7308C57.1261 12.4558 55.7229 13.8557 53.9938 13.8557Z"
            fill="#ec2a26"
          />
          <path
            d="M66.8093 4.93091C63.6213 4.93091 61.0264 7.51974 61.0264 10.7002C61.0264 13.8807 63.6213 16.4696 66.8093 16.4696C69.9972 16.4696 72.5922 13.8807 72.5922 10.7002C72.5922 7.51974 69.9972 4.93091 66.8093 4.93091ZM66.8399 13.8557C65.1137 13.8557 63.7076 12.453 63.7076 10.7308C63.7076 9.0086 65.1109 7.60585 66.8399 7.60585C68.5689 7.60585 69.9722 9.00582 69.9722 10.7308C69.9722 12.4558 68.5661 13.8557 66.8399 13.8557Z"
            fill="#ec2a26"
          />
          <path
            d="M41.4972 5.21701H40.6063C40.0327 5.21701 39.5399 5.55312 39.3116 6.03922C39.1306 5.90867 38.9468 5.78367 38.7492 5.67534C37.886 5.18924 36.9032 4.93091 35.9064 4.93091C32.7185 4.93091 30.1235 7.51974 30.1235 10.7002C30.1235 13.8807 32.7185 16.4696 35.9064 16.4696C36.8475 16.4696 37.783 16.239 38.6099 15.8001C38.8076 15.6946 38.9942 15.5779 39.1779 15.4557C39.1779 16.5168 38.3176 17.3751 37.2568 17.3779H37.0925C36.3213 17.3779 35.6976 18.0029 35.6976 18.7723V19.5001C35.6976 19.775 35.9204 20 36.1988 20H37.6939C40.0717 20 42.0012 18.0779 42.0012 15.7029V5.71423C42.0012 5.43923 41.7784 5.21423 41.5 5.21423L41.4972 5.21701ZM38.248 12.628C37.6048 13.4696 36.5997 13.9252 35.5278 13.8502C33.9909 13.7418 32.7463 12.4946 32.6377 10.9613C32.5069 9.13638 33.9575 7.61141 35.7589 7.61141C36.7445 7.61141 37.6494 8.05862 38.248 8.83916C38.6684 9.38637 38.8884 10.0419 38.8884 10.7336C38.8884 11.4252 38.6656 12.0808 38.2452 12.628H38.248Z"
            fill="#ec2a26"
          />
        </svg>

        <h1
          class="mt-6 text-center font-sans text-xl leading-tight font-bold tracking-tight text-[#1a1a1a] md:text-2xl"
        >
          You have received a short-term access link.
        </h1>

        <p class="mt-4 text-center text-xs leading-relaxed text-gray-500 md:text-sm">
          Tap the <strong class="font-extrabold text-gray-800">"OPEN"</strong> button at the top
          right of your screen to launch the App Clip instantly - No App store visit, waiting or
          download required
        </p>

        <!-- Divider Label -->
        <p class="mt-6 mb-4 text-center text-xs text-gray-500">Step by step guide</p>

        <!-- Guide Steps Table: images bottom-aligned, labels top-aligned -->
        <div class="w-full border-t border-b border-gray-50 py-5">
          <table class="w-full table-fixed select-none">
            <colgroup>
              <col style="width: 46%" />
              <col style="width: 8%" />
              <col style="width: 46%" />
            </colgroup>
            <tbody>
              <!-- Image row: each mockup sits at the bottom of the cell -->
              <tr>
                <td class="pb-2 text-center align-bottom">
                  <!-- Step 1: Smart Banner mockup -->
                  <div
                    class="inline-flex w-full max-w-42.5 items-center gap-1.5 rounded-lg border border-gray-100 bg-[#f9fafb] p-1.5 shadow-sm"
                  >
                    <div
                      class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md"
                      [style.background-color]="brand.iconBgColor"
                    >
                      <svg
                        class="h-3.5 w-3.5 text-white"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="6"
                          y="14"
                          width="20"
                          height="15"
                          rx="3.5"
                          stroke="currentColor"
                          stroke-width="2"
                          fill="none"
                        />
                        <path
                          d="M11 14v-3.5a5 5 0 0 1 10 0V14"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                        <circle cx="16" cy="21.5" r="2.5" fill="currentColor" />
                      </svg>
                    </div>
                    <div class="min-w-0 flex-1 text-left">
                      <p class="truncate text-[8px] leading-none font-bold text-gray-800">
                        {{ brand.displayName }}
                      </p>
                      <p class="mt-1 truncate text-[6px] leading-none text-gray-400">
                        Open in App Clip
                      </p>
                    </div>
                    <span
                      class="shrink-0 rounded-full bg-[#007aff] px-2 py-0.5 text-[7px] font-bold tracking-wider text-white uppercase"
                      >Open</span
                    >
                  </div>
                </td>
                <!-- Arrow spans both rows, stays vertically centred -->
                <td
                  class="w-8 text-center align-middle text-base font-bold text-gray-300"
                  rowspan="2"
                >
                  →
                </td>
                <td class="pb-2 text-center align-bottom">
                  <!-- Step 2: App Clip card mockup -->
                  <div
                    class="inline-flex w-full max-w-37.5 flex-col overflow-hidden rounded-xl border border-gray-100 bg-white text-left shadow-md"
                  >
                    <!-- Teal header: igloo wordmark + lock silhouettes + close -->
                    <div
                      class="relative flex items-center justify-between px-2 py-1.5"
                      [style.background-color]="brand.iconBgColor"
                    >
                      <svg
                        class="absolute inset-0 h-full w-full opacity-15"
                        viewBox="0 0 150 32"
                        fill="none"
                        preserveAspectRatio="xMidYMid slice"
                      >
                        <rect
                          x="4"
                          y="7"
                          width="14"
                          height="12"
                          rx="2"
                          stroke="white"
                          stroke-width="1"
                          fill="none"
                        />
                        <path
                          d="M7 7V4a5 5 0 0 1 8 0v3"
                          stroke="white"
                          stroke-width="1"
                          stroke-linecap="round"
                          fill="none"
                        />
                        <circle cx="42" cy="16" r="8" stroke="white" stroke-width="1" fill="none" />
                        <circle cx="42" cy="16" r="3" stroke="white" stroke-width="1" fill="none" />
                        <rect
                          x="68"
                          y="4"
                          width="12"
                          height="24"
                          rx="2"
                          stroke="white"
                          stroke-width="1"
                          fill="none"
                        />
                        <rect
                          x="72"
                          y="8"
                          width="5"
                          height="4"
                          rx="1"
                          stroke="white"
                          stroke-width="0.7"
                          fill="none"
                        />
                        <rect
                          x="100"
                          y="7"
                          width="14"
                          height="12"
                          rx="2"
                          stroke="white"
                          stroke-width="1"
                          fill="none"
                        />
                        <path
                          d="M103 7V4a5 5 0 0 1 8 0v3"
                          stroke="white"
                          stroke-width="1"
                          stroke-linecap="round"
                          fill="none"
                        />
                        <rect
                          x="124"
                          y="3"
                          width="22"
                          height="26"
                          rx="2"
                          stroke="white"
                          stroke-width="1"
                          fill="none"
                        />
                        <rect
                          x="128"
                          y="8"
                          width="6"
                          height="4"
                          rx="1"
                          stroke="white"
                          stroke-width="0.7"
                          fill="none"
                        />
                        <rect
                          x="137"
                          y="8"
                          width="6"
                          height="4"
                          rx="1"
                          stroke="white"
                          stroke-width="0.7"
                          fill="none"
                        />
                      </svg>
                      <svg
                        width="42"
                        height="11"
                        viewBox="0 0 73 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="relative z-10 shrink-0"
                      >
                        <path
                          d="M0 5.43044V19.994H14.5979C17.6048 19.994 20.0411 17.5635 20.0411 14.5636V0H5.44322C2.43622 0 0 2.43051 0 5.43044ZM14.5282 18.1691C12.5208 18.1691 10.8948 16.5469 10.8948 14.5441C10.8948 12.5414 12.5208 10.9192 14.5282 10.9192C16.5357 10.9192 18.1617 12.5414 18.1617 14.5441C18.1617 16.5469 16.5357 18.1691 14.5282 18.1691ZM18.1812 1.83885V9.12759H10.8753C10.8753 5.10267 14.1468 1.83885 18.1812 1.83885ZM9.14628 1.83885V18.1718H1.81812V5.48878C1.81812 3.47215 3.45526 1.83885 5.47663 1.83885H9.14628Z"
                          fill="white"
                        />
                        <path
                          d="M27.9775 5.18652H27.3343C26.5046 5.18652 25.8336 5.85595 25.8336 6.68371V15.9141C25.8336 16.2196 26.0842 16.4696 26.3905 16.4696H27.9775C28.2921 16.4696 28.5483 16.2141 28.5483 15.9002V5.75874C28.5483 5.44485 28.2921 5.1893 27.9775 5.1893V5.18652Z"
                          fill="white"
                        />
                        <path
                          d="M46.014 0.0065918H45.3708C44.5411 0.0065918 43.8701 0.676024 43.8701 1.50378V15.9146C43.8701 16.2201 44.1207 16.4701 44.427 16.4701H46.014C46.3286 16.4701 46.5848 16.2146 46.5848 15.9007V0.578804C46.5848 0.264921 46.3286 0.00937011 46.014 0.00937011V0.0065918Z"
                          fill="white"
                        />
                        <path
                          d="M27.1888 0.295166C26.1586 0.295166 25.3177 1.13126 25.3177 2.16179C25.3177 3.19233 26.1558 4.02842 27.1888 4.02842C28.2217 4.02842 29.0598 3.19233 29.0598 2.16179C29.0598 1.13126 28.2217 0.295166 27.1888 0.295166Z"
                          fill="white"
                        />
                        <path
                          d="M53.9632 4.93091C50.7752 4.93091 48.1803 7.51974 48.1803 10.7002C48.1803 13.8807 50.7752 16.4696 53.9632 16.4696C57.1512 16.4696 59.7461 13.8807 59.7461 10.7002C59.7461 7.51974 57.1512 4.93091 53.9632 4.93091ZM53.9938 13.8557C52.2676 13.8557 50.8615 12.453 50.8615 10.7308C50.8615 9.0086 52.2648 7.60585 53.9938 7.60585C55.7229 7.60585 57.1261 9.00582 57.1261 10.7308C57.1261 12.4558 55.7229 13.8557 53.9938 13.8557Z"
                          fill="white"
                        />
                        <path
                          d="M66.8093 4.93091C63.6213 4.93091 61.0264 7.51974 61.0264 10.7002C61.0264 13.8807 63.6213 16.4696 66.8093 16.4696C69.9972 16.4696 72.5922 13.8807 72.5922 10.7002C72.5922 7.51974 69.9972 4.93091 66.8093 4.93091ZM66.8399 13.8557C65.1137 13.8557 63.7076 12.453 63.7076 10.7308C63.7076 9.0086 65.1109 7.60585 66.8399 7.60585C68.5689 7.60585 69.9722 9.00582 69.9722 10.7308C69.9722 12.4558 68.5661 13.8557 66.8399 13.8557Z"
                          fill="white"
                        />
                        <path
                          d="M41.4972 5.21701H40.6063C40.0327 5.21701 39.5399 5.55312 39.3116 6.03922C39.1306 5.90867 38.9468 5.78367 38.7492 5.67534C37.886 5.18924 36.9032 4.93091 35.9064 4.93091C32.7185 4.93091 30.1235 7.51974 30.1235 10.7002C30.1235 13.8807 32.7185 16.4696 35.9064 16.4696C36.8475 16.4696 37.783 16.239 38.6099 15.8001C38.8076 15.6946 38.9942 15.5779 39.1779 15.4557C39.1779 16.5168 38.3176 17.3751 37.2568 17.3779H37.0925C36.3213 17.3779 35.6976 18.0029 35.6976 18.7723V19.5001C35.6976 19.775 35.9204 20 36.1988 20H37.6939C40.0717 20 42.0012 18.0779 42.0012 15.7029V5.71423C42.0012 5.43923 41.7784 5.21423 41.5 5.21423L41.4972 5.21701ZM38.248 12.628C37.6048 13.4696 36.5997 13.9252 35.5278 13.8502C33.9909 13.7418 32.7463 12.4946 32.6377 10.9613C32.5069 9.13638 33.9575 7.61141 35.7589 7.61141C36.7445 7.61141 37.6494 8.05862 38.248 8.83916C38.6684 9.38637 38.8884 10.0419 38.8884 10.7336C38.8884 11.4252 38.6656 12.0808 38.2452 12.628H38.248Z"
                          fill="white"
                        />
                      </svg>
                      <div
                        class="relative z-10 flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full bg-white/25"
                      >
                        <span class="text-[7px] leading-none text-white">✕</span>
                      </div>
                    </div>
                    <!-- Body: title+subtitle left, Open pill right -->
                    <div class="flex items-center gap-1.5 px-2 py-2">
                      <div class="min-w-0 flex-1">
                        <p class="text-[8px] leading-none font-bold text-gray-900">iglooKey</p>
                        <p class="mt-0.5 text-[5px] leading-tight text-gray-500">
                          Tap Open to unlock with iglooKey
                        </p>
                      </div>
                      <span
                        class="shrink-0 rounded-full bg-[#007aff] px-2.5 py-1 text-[7px] font-bold text-white"
                        >Open</span
                      >
                    </div>
                    <!-- Footer -->
                    <div
                      class="flex items-center justify-between border-t border-gray-100 px-2 py-1"
                    >
                      <div class="flex items-center gap-1">
                        <div
                          class="flex h-3 w-3 shrink-0 items-center justify-center rounded-sm"
                          [style.background-color]="brand.iconBgColor"
                        >
                          <svg class="h-2 w-2 text-white" viewBox="0 0 20 20" fill="none">
                            <rect
                              x="4"
                              y="9"
                              width="12"
                              height="9"
                              rx="2"
                              stroke="currentColor"
                              stroke-width="2"
                              fill="none"
                            />
                            <path
                              d="M7 9V6.5a3 3 0 0 1 6 0V9"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              fill="none"
                            />
                          </svg>
                        </div>
                        <span class="text-[5px] text-gray-500"
                          >Powered by <span class="font-semibold">igloo</span></span
                        >
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <!-- Label row: text starts at the top, aligned across all steps -->
              <tr>
                <td class="pt-3 text-center align-top">
                  <p class="text-[11px] leading-tight font-semibold text-gray-500">
                    Tap Open<br />from Top banner
                  </p>
                </td>
                <td class="pt-3 text-center align-top">
                  <p class="text-[11px] leading-tight font-semibold text-gray-500">
                    Tap Open<br />on App Clip
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer Card Text -->
        @if (platformService.isSafari) {
          <p class="mt-6 text-center text-xs text-gray-500">No Download Required</p>
        }
        @if (!platformService.isSafari) {
          <div class="mt-5 w-full border-t border-gray-100 pt-4 text-center">
            <p class="text-[12px] text-gray-500">Not seeing the Open button?</p>
            <a
              [href]="safariUrl"
              class="mt-1 inline-block text-[12px] font-semibold"
              [style.color]="brand.iconBgColor"
              >Try opening in Safari →</a
            >
          </div>
        }
      </div>
    </div>
  }
} @else if (platformService.isDesktop) {
  <!-- Desktop: "open on mobile" error page -->
  <div
    class="flex min-h-dvh w-full flex-col items-center justify-center gap-4 p-6 text-center"
    [style.background-color]="brand.pageBgColor"
    [style.color]="brand.iconBgColor"
  >
    <svg
      width="110"
      height="30"
      viewBox="0 0 73 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="mx-auto select-none"
    >
      <path
        d="M0 5.43044V19.994H14.5979C17.6048 19.994 20.0411 17.5635 20.0411 14.5636V0H5.44322C2.43622 0 0 2.43051 0 5.43044ZM14.5282 18.1691C12.5208 18.1691 10.8948 16.5469 10.8948 14.5441C10.8948 12.5414 12.5208 10.9192 14.5282 10.9192C16.5357 10.9192 18.1617 12.5414 18.1617 14.5441C18.1617 16.5469 16.5357 18.1691 14.5282 18.1691ZM18.1812 1.83885V9.12759H10.8753C10.8753 5.10267 14.1468 1.83885 18.1812 1.83885ZM9.14628 1.83885V18.1718H1.81812V5.48878C1.81812 3.47215 3.45526 1.83885 5.47663 1.83885H9.14628Z"
        [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
      />
      <path
        d="M27.9775 5.18652H27.3343C26.5046 5.18652 25.8336 5.85595 25.8336 6.68371V15.9141C25.8336 16.2196 26.0842 16.4696 26.3905 16.4696H27.9775C28.2921 16.4696 28.5483 16.2141 28.5483 15.9002V5.75874C28.5483 5.44485 28.2921 5.1893 27.9775 5.1893V5.18652Z"
        [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
      />
      <path
        d="M46.014 0.0065918H45.3708C44.5411 0.0065918 43.8701 0.676024 43.8701 1.50378V15.9146C43.8701 16.2201 44.1207 16.4701 44.427 16.4701H46.014C46.3286 16.4701 46.5848 16.2146 46.5848 15.9007V0.578804C46.5848 0.264921 46.3286 0.00937011 46.014 0.00937011V0.0065918Z"
        [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
      />
      <path
        d="M27.1888 0.295166C26.1586 0.295166 25.3177 1.13126 25.3177 2.16179C25.3177 3.19233 26.1558 4.02842 27.1888 4.02842C28.2217 4.02842 29.0598 3.19233 29.0598 2.16179C29.0598 1.13126 28.2217 0.295166 27.1888 0.295166Z"
        [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
      />
      <path
        d="M53.9632 4.93091C50.7752 4.93091 48.1803 7.51974 48.1803 10.7002C48.1803 13.8807 50.7752 16.4696 53.9632 16.4696C57.1512 16.4696 59.7461 13.8807 59.7461 10.7002C59.7461 7.51974 57.1512 4.93091 53.9632 4.93091ZM53.9938 13.8557C52.2676 13.8557 50.8615 12.453 50.8615 10.7308C50.8615 9.0086 52.2648 7.60585 53.9938 7.60585C55.7229 7.60585 57.1261 9.00582 57.1261 10.7308C57.1261 12.4558 55.7229 13.8557 53.9938 13.8557Z"
        [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
      />
      <path
        d="M66.8093 4.93091C63.6213 4.93091 61.0264 7.51974 61.0264 10.7002C61.0264 13.8807 63.6213 16.4696 66.8093 16.4696C69.9972 16.4696 72.5922 13.8807 72.5922 10.7002C72.5922 7.51974 69.9972 4.93091 66.8093 4.93091ZM66.8399 13.8557C65.1137 13.8557 63.7076 12.453 63.7076 10.7308C63.7076 9.0086 65.1109 7.60585 66.8399 7.60585C68.5689 7.60585 69.9722 9.00582 69.9722 10.7308C69.9722 12.4558 68.5661 13.8557 66.8399 13.8557Z"
        [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
      />
      <path
        d="M41.4972 5.21701H40.6063C40.0327 5.21701 39.5399 5.55312 39.3116 6.03922C39.1306 5.90867 38.9468 5.78367 38.7492 5.67534C37.886 5.18924 36.9032 4.93091 35.9064 4.93091C32.7185 4.93091 30.1235 7.51974 30.1235 10.7002C30.1235 13.8807 32.7185 16.4696 35.9064 16.4696C36.8475 16.4696 37.783 16.239 38.6099 15.8001C38.8076 15.6946 38.9942 15.5779 39.1779 15.4557C39.1779 16.5168 38.3176 17.3751 37.2568 17.3779H37.0925C36.3213 17.3779 35.6976 18.0029 35.6976 18.7723V19.5001C35.6976 19.775 35.9204 20 36.1988 20H37.6939C40.0717 20 42.0012 18.0779 42.0012 15.7029V5.71423C42.0012 5.43923 41.7784 5.21423 41.5 5.21423L41.4972 5.21701ZM38.248 12.628C37.6048 13.4696 36.5997 13.9252 35.5278 13.8502C33.9909 13.7418 32.7463 12.4946 32.6377 10.9613C32.5069 9.13638 33.9575 7.61141 35.7589 7.61141C36.7445 7.61141 37.6494 8.05862 38.248 8.83916C38.6684 9.38637 38.8884 10.0419 38.8884 10.7336C38.8884 11.4252 38.6656 12.0808 38.2452 12.628H38.248Z"
        [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
      />
    </svg>
    <h1 class="text-2xl font-bold" [style.color]="brand.pageFgColor">iglooKey Failed to Open</h1>
    <p class="text-sm opacity-80" [style.color]="brand.pageFgColor">
      Please open the link via a mobile browser
    </p>
  </div>
} @else {
  <!-- Android background: unlock page if BLE available, teal fallback if not -->
  @if (platformService.hasWebBleSupport) {
    <app-unlock-page />
  } @else {
    <div
      class="flex min-h-dvh w-full flex-col items-center justify-center p-6 text-center"
      [style.background-color]="brand.pageBgColor"
      [style.color]="brand.iconBgColor"
    >
      <svg
        width="110"
        height="30"
        viewBox="0 0 73 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mx-auto mb-4 select-none"
      >
        <path
          d="M0 5.43044V19.994H14.5979C17.6048 19.994 20.0411 17.5635 20.0411 14.5636V0H5.44322C2.43622 0 0 2.43051 0 5.43044ZM14.5282 18.1691C12.5208 18.1691 10.8948 16.5469 10.8948 14.5441C10.8948 12.5414 12.5208 10.9192 14.5282 10.9192C16.5357 10.9192 18.1617 12.5414 18.1617 14.5441C18.1617 16.5469 16.5357 18.1691 14.5282 18.1691ZM18.1812 1.83885V9.12759H10.8753C10.8753 5.10267 14.1468 1.83885 18.1812 1.83885ZM9.14628 1.83885V18.1718H1.81812V5.48878C1.81812 3.47215 3.45526 1.83885 5.47663 1.83885H9.14628Z"
          [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
        />
        <path
          d="M27.9775 5.18652H27.3343C26.5046 5.18652 25.8336 5.85595 25.8336 6.68371V15.9141C25.8336 16.2196 26.0842 16.4696 26.3905 16.4696H27.9775C28.2921 16.4696 28.5483 16.2141 28.5483 15.9002V5.75874C28.5483 5.44485 28.2921 5.1893 27.9775 5.1893V5.18652Z"
          [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
        />
        <path
          d="M46.014 0.0065918H45.3708C44.5411 0.0065918 43.8701 0.676024 43.8701 1.50378V15.9146C43.8701 16.2201 44.1207 16.4701 44.427 16.4701H46.014C46.3286 16.4701 46.5848 16.2146 46.5848 15.9007V0.578804C46.5848 0.264921 46.3286 0.00937011 46.014 0.00937011V0.0065918Z"
          [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
        />
        <path
          d="M27.1888 0.295166C26.1586 0.295166 25.3177 1.13126 25.3177 2.16179C25.3177 3.19233 26.1558 4.02842 27.1888 4.02842C28.2217 4.02842 29.0598 3.19233 29.0598 2.16179C29.0598 1.13126 28.2217 0.295166 27.1888 0.295166Z"
          [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
        />
        <path
          d="M53.9632 4.93091C50.7752 4.93091 48.1803 7.51974 48.1803 10.7002C48.1803 13.8807 50.7752 16.4696 53.9632 16.4696C57.1512 16.4696 59.7461 13.8807 59.7461 10.7002C59.7461 7.51974 57.1512 4.93091 53.9632 4.93091ZM53.9938 13.8557C52.2676 13.8557 50.8615 12.453 50.8615 10.7308C50.8615 9.0086 52.2648 7.60585 53.9938 7.60585C55.7229 7.60585 57.1261 9.00582 57.1261 10.7308C57.1261 12.4558 55.7229 13.8557 53.9938 13.8557Z"
          [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
        />
        <path
          d="M66.8093 4.93091C63.6213 4.93091 61.0264 7.51974 61.0264 10.7002C61.0264 13.8807 63.6213 16.4696 66.8093 16.4696C69.9972 16.4696 72.5922 13.8807 72.5922 10.7002C72.5922 7.51974 69.9972 4.93091 66.8093 4.93091ZM66.8399 13.8557C65.1137 13.8557 63.7076 12.453 63.7076 10.7308C63.7076 9.0086 65.1109 7.60585 66.8399 7.60585C68.5689 7.60585 69.9722 9.00582 69.9722 10.7308C69.9722 12.4558 68.5661 13.8557 66.8399 13.8557Z"
          [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
        />
        <path
          d="M41.4972 5.21701H40.6063C40.0327 5.21701 39.5399 5.55312 39.3116 6.03922C39.1306 5.90867 38.9468 5.78367 38.7492 5.67534C37.886 5.18924 36.9032 4.93091 35.9064 4.93091C32.7185 4.93091 30.1235 7.51974 30.1235 10.7002C30.1235 13.8807 32.7185 16.4696 35.9064 16.4696C36.8475 16.4696 37.783 16.239 38.6099 15.8001C38.8076 15.6946 38.9942 15.5779 39.1779 15.4557C39.1779 16.5168 38.3176 17.3751 37.2568 17.3779H37.0925C36.3213 17.3779 35.6976 18.0029 35.6976 18.7723V19.5001C35.6976 19.775 35.9204 20 36.1988 20H37.6939C40.0717 20 42.0012 18.0779 42.0012 15.7029V5.71423C42.0012 5.43923 41.7784 5.21423 41.5 5.21423L41.4972 5.21701ZM38.248 12.628C37.6048 13.4696 36.5997 13.9252 35.5278 13.8502C33.9909 13.7418 32.7463 12.4946 32.6377 10.9613C32.5069 9.13638 33.9575 7.61141 35.7589 7.61141C36.7445 7.61141 37.6494 8.05862 38.248 8.83916C38.6684 9.38637 38.8884 10.0419 38.8884 10.7336C38.8884 11.4252 38.6656 12.0808 38.2452 12.628H38.248Z"
          [attr.fill]="brand.id === 'iglooworks' ? 'currentColor' : 'white'"
        />
      </svg>
      <h1 class="mb-2 text-xl font-bold" [style.color]="brand.pageFgColor">
        iglooKey Failed to Open
      </h1>
      <p class="mb-4 text-sm opacity-70" [style.color]="brand.pageFgColor">
        Please open the iglooKey with the app
      </p>
      <button
        (click)="openApp()"
        class="cursor-pointer text-sm font-semibold uppercase underline decoration-2 underline-offset-4 transition-opacity hover:opacity-90 focus:outline-none"
      >
        Open App
      </button>
    </div>
  }

  <!-- Dialog overlays BLE-supported Android only (user has web vs app choice) -->
  @if (platformService.hasWebBleSupport && showAndroidDialog()) {
    <div class="fixed inset-0 z-[9998] bg-black/60"></div>
    <div
      class="fixed inset-0 z-[9999] flex items-center justify-center px-8"
      role="button"
      tabindex="0"
      (click)="dismissDialog()"
      (keydown.escape)="dismissDialog()"
    >
      <div
        class="w-full max-w-xs overflow-hidden rounded-2xl bg-white shadow-2xl"
        role="dialog"
        tabindex="-1"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
      >
        <div class="px-6 pt-6 pb-5 text-center">
          <div class="mb-4 flex justify-center">
            <div
              class="flex h-14 w-14 items-center justify-center rounded-2xl p-2.5"
              [style.background-color]="brand.iconBgColor"
            >
              @if (brand.iconPathData) {
                <svg
                  viewBox="0 0 20.1 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-full w-full"
                >
                  <path [attr.d]="brand.iconPathData" fill="white" />
                </svg>
              } @else {
                <span class="text-xl font-bold text-white">{{
                  brand.displayName.charAt(0).toUpperCase()
                }}</span>
              }
            </div>
          </div>
          <h2 class="text-xl font-bold text-gray-900">Open in app</h2>
          <p class="mt-1 text-sm text-gray-500">Open with {{ brand.displayName }} app</p>
        </div>
        <div class="h-px bg-gray-100"></div>
        <div class="flex">
          <button
            type="button"
            class="flex-1 py-4 text-sm font-bold tracking-widest text-gray-400 uppercase transition-colors active:bg-gray-50"
            (click)="dismissDialog()"
          >
            Cancel
          </button>
          <div class="w-px bg-gray-100"></div>
          <button
            type="button"
            class="flex-1 py-4 text-sm font-bold tracking-widest uppercase transition-colors active:bg-gray-50"
            [style.color]="brand.iconBgColor"
            (click)="openApp()"
          >
            Open App
          </button>
        </div>
      </div>
    </div>
  }
}
